<template lang="pug">
  a.panel(href="#" @click.prevent.stop="click")
    .existing(v-if="address")
      MapBox(:address="address" :padding="padding")
      .info.bg-gray-200.p-2.text-sm(ref="info")
        p.text-gray-500 {{ name }}
        p(v-if="address.street") {{ address.street }}
        p(v-if="address.zipcode || address.city") {{ address.zipcode }} {{ address.city }}
        p(v-if="address.country") {{ address.country | country }}
        .defaults(v-if="address.default_billing || address.default_shipping")
          hr.my-2
          .billing(v-if="address.default_billing") Standard Rechnungsadresse
          .shipping(v-if="address.default_shipping") Standard Lieferadresse
        button.delete-button(v-else @click.prevent.stop="showDeleteDialog = true")
          svg(
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          )
            path(
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
            )
    template(v-else)
      svg.add-icon(
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      )
        path(
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.3"
          d="M12 6v6m0 0v6m0-6h6m-6 0H6"
        )
      p Adresse hinzufügen

    portal(to="modals")
      Modal(v-if="showDeleteDialog" size="sm" @dismiss="showDeleteDialog = false" @close="showDeleteDialog = false")
        .p-4.bg-gray-200.rounded-t
          .alert.danger
            p Soll diese Adresse wirklich gelöscht werden?
            blockquote.text-sm.mt-4
              p {{ name }}
              p(v-if="company") Firma: {{ company }}
              p {{ address.street }}
              p {{ address.zipcode }} {{ address.city }}
              p(v-if="address.country") {{ address.country | country }}
        .bg-gray-100.p-4.rounded-b(class="md:flex md:flex-row-reverse md:justify-between")
          button.button.is-danger(type="button" @click="deleteAddress") Adresse löschen
          button.button.is-outlined(type="button" @click="showDeleteDialog = false") Abbrechen

      Modal(v-else-if="modal" size="md" @dismiss="dismiss" @close="close")
        validation-observer(v-slot="{ invalid }" ref="form")
          Spinner(v-if="loading" :size="16" :thickness="3")
          .p-4.bg-gray-200.rounded-t
            .preview(v-show="preview")
              .alert.info.mb-4(v-if="addresses && addresses.length > 0")
                p(v-if="addresses.length > 1") Wir haben folgende Adressen gefunden. Stimmt die Auswahl?
                p(v-else) Wir haben diese Adresse gefunden. Stimmt sie?
              .alert.warning.mb-4(v-else)
                p Wir konnten Ihre Adresse nicht finden. Sind Ihre Angaben korrekt?
                blockquote.text-sm.mt-4
                  p {{ name }}
                  p(v-if="company") Firma: {{ company }}
                  p {{ form.street }}
                  p {{ form.zipcode }} {{ form.city }}
                  p(v-if="form.country") {{ form.country.label }}
              .alert.warning.mb-4(v-if="selectedAddress && !selectedAddress.data.address")
                p(v-if="addresses.length > 1") Die Ausgewählte Adresse hat keine Hausnummer. Dies kann zu Schwierigkeiten bei der Zustellung führen.
                p(v-else) Ihre Adresse hat keine Hausnummer. Dies kann zu Schwierigkeiten bei der Zustellung führen.
              .content(:class="{ grid: addresses && addresses.length > 0 }")
                MapBox(:address="selectedAddress")
                ul.addresses-list
                  li(v-for="address in addresses")
                    p-radio(
                      v-model="selectedAddress"
                      name="selectedAddress"
                      color="dark"
                      :value="address"
                    )
                      | {{ address.value }}
            form(v-show="!preview" @submit.prevent="submit")
              .alert.mb-4(v-if="form.edit_member === false")
                p.text-gray-600 {{ name }}
                p.text-gray-600(v-if="company") Firma: {{ company }}
                a(href="#" @click.prevent.default="form.edit_member = true") ändern

              // add gender, first_name and last_name fields
              .member-fields(v-if="form.edit_member")
                .trible-field
                  .field
                    fieldset.form-field
                      label.label Anrede
                      multiselect(
                        v-model="form.gender"
                        :options="genders"
                        :multiple="false"
                        :searchable="false"
                        :allow-empty="true"
                        :show-labels="true"
                        track-by="value"
                        label="label"
                        :placeholder="salutation"
                        deselect-label=""
                        selected-label=""
                        select-label=""
                      )
                  .field
                    fieldset.form-field
                      label.label(for="first-name") Vorname
                      .control.has-icons-right
                        input#first-name.input(
                          type="text"
                          name="first_name"
                          v-model="form.first_name"
                          :placeholder="member.first_name"
                        )
                        span.icon
                          font-awesome-icon(icon="user")
                  .field
                    fieldset.form-field
                      label.label(for="last-name") Nachname
                      .control.has-icons-right
                        input#last-name.input(
                          type="text"
                          name="last_name"
                          v-model="form.last_name"
                          :placeholder="member.last_name"
                        )
                        span.icon
                          font-awesome-icon(icon="user")
                .company-fields.double-field
                  .field
                    fieldset.form-field
                      label.label(for="company") Firma
                      .control.has-icons-right
                        input#company.input(
                          type="text"
                          name="company"
                          v-model="form.company"
                          :placeholder="member.company"
                        )
                        span.icon
                          font-awesome-icon(icon="building")
                  .field
                    fieldset.form-field
                      label.label(for="company-addition") Firmenzusatz
                      .control.has-icons-right
                        input#company-addition.input(
                          type="text"
                          name="company_addition"
                          v-model="form.company_addition"
                        )
                        span.icon
                          font-awesome-icon(icon="reply")

              .double-field
                .field
                  fieldset.form-field
                    validation-provider(name="Straße" rules="required" v-slot="{ errors }")
                      label.label(for="street") Straße, Hausnummer
                      .control.has-icons-right
                        input#street.input(
                          type="text"
                          name="street"
                          v-model="form.street"
                          :class="{ 'is-danger': errors && errors.length }"
                        )
                        span.icon
                          font-awesome-icon(icon="map-signs")
                      p.help.is-danger(v-if="errors && errors.length") {{ errors[0] }}
                      p.help.has-text-grey(v-else) Pflichtfeld
                .field
                  fieldset.form-field
                    label.label(for="street-addition") Zusatz
                    .control.has-icons-right
                      input#street-addition.input(
                        type="text"
                        name="street-addition"
                        v-model="form.street_addition"
                      )
                      span.icon
                        font-awesome-icon(icon="directions")
              .double-field
                .field
                  fieldset.form-field
                    validation-provider(name="Postleitzahl" rules="required" v-slot="{ errors }")
                      label.label(for="zipcode") Postleitzahl
                      .control.has-icons-right
                        input#zipcode.input(
                          type="text"
                          name="zipcode"
                          v-model="form.zipcode"
                          :class="{ 'is-danger': errors && errors.length }"
                        )
                        span.icon
                          font-awesome-icon(icon="location-arrow")
                      p.help.is-danger(v-if="errors && errors.length") {{ errors[0] }}
                      p.help.has-text-grey(v-else) Pflichtfeld
                .field
                  fieldset.form-field
                    validation-provider(name="Ort" rules="required" v-slot="{ errors }")
                      label.label(for="city") Ort
                      .control.has-icons-right
                        input#city.input(
                          type="text"
                          name="city"
                          v-model="form.city"
                          :class="{ 'is-danger': errors && errors.length }"
                        )
                        span.icon
                          font-awesome-icon(icon="city")
                      p.help.is-danger(v-if="errors && errors.length") {{ errors[0] }}
                      p.help.has-text-grey(v-else) Pflichtfeld
              fieldset
                select-with-validation.select-field(
                  rules="required"
                  name="Land"
                  v-model="form.country"
                  :options="countries"
                  :multiple="false"
                  :searchable="true"
                  :loading="loadingCountries"
                  :allow-empty="true"
                  :show-labels="true"
                  track-by="code"
                  label="label"
                  placeholder="suchen..."
                  deselect-label="mit Enter abwählen"
                  selected-label="ausgewählt"
                  select-label="mit Enter auswählen"
                  @search-change="findCountries"
                )
                  template(v-slot:noOptions) Bitte machen Sie eine Eingabe, damit ein passender Ländername gefunden werden kann.
                  template(v-slot:noResult) Es konnte kein passender Ländername gefunden werden.
              .double-field
                .field
                  fieldset.form-field
                    p-check(
                      name="default_billing"
                      color="dark"
                      v-model="form.default_billing"
                      :disabled="!defaultBillingAddressExists || (form.id && address.default_billing)"
                    )
                      | Standard Rechnungsadresse
                .field
                  fieldset.form-field
                    p-check(
                      name="default_shipping"
                      color="dark"
                      v-model="form.default_shipping"
                      :disabled="!defaultShippingAddressExists || (form.id && address.default_shipping)"
                    )
                      | Standard Lieferadresse
          .bg-gray-100.p-4.rounded-b(class="md:flex md:flex-row-reverse md:justify-between")
            template(v-if="preview && addresses && addresses.length > 0")
              .buttons
                button.button.is-outlined(
                  type="button"
                  @click="save"
                  :disabled="invalid"
                ) Adresse stimmt nicht, meine Angaben trotzdem speichern
                button.button.is-outlined(
                  type="button"
                  @click="correct"
                  :disabled="invalid"
                ) Korrigieren
                button.button(type="button" @click="submit" :disabled="invalid") Speichern
              button.button.is-outlined(type="button" @click="close") Abbrechen
            template(v-else-if="preview")
              .buttons
                button.button.is-outlined(
                  type="button"
                  @click="correct"
                  :disabled="invalid"
                ) Korrigieren
                button.button(type="button" @click="save" :disabled="invalid") Meine Angaben sind korrekt, speichern
              button.button.is-outlined(type="button" @click="close") Abbrechen
            template(v-else)
              button.button(v-if="validMapboxKey && dirty" type="button" @click="submit" :disabled="invalid") Weiter
              button.button(v-else type="button" @click="save" :disabled="invalid") Adresse speichern
              button.button.is-outlined(type="button" @click="close") Abbrechen
</template>

<script>
import Vue from 'vue';
import uniqid from 'uniqid';
import Fuse from 'fuse.js';
import axios from 'axios';

import { mapGetters, mapActions } from 'vuex';
import { getTime, startOfDay } from 'date-fns';

import { VueReCaptcha } from 'vue-recaptcha-v3';
import { ValidationObserver, ValidationProvider } from 'vee-validate';

import countries from 'i18n-iso-countries';
import de from 'i18n-iso-countries/langs/de.json';
countries.registerLocale(de);

// name = countries.getName(code, language);
// code = countries.getAlpha2Code(entry.text, 'de')

import { get, cloneDeep, trim, debounce } from '@/helpers';

import Multiselect from 'vue-multiselect';

import SelectWithValidation from '@/components/Partials/SelectWithValidation';
import EditIcon from '@/extensions/restricted-area/components/UserForm/Partials/EditIcon';
import Modal from '@/components/Modal';
import MapBox from './MapBox';

export default {
    name: 'Address',
    props: {
        address: {
            type: Object,
            required: false
        }
    },
    data: () => ({
        modal: false,
        showDeleteDialog: false,
        loading: false,
        padding: { bottom: 80 },
        proximity: [10.4515, 51.1657], // default: germany
        genders: [
            {
                value: 'M',
                label: 'Herr'
            },
            {
                value: 'F',
                label: 'Frau'
            },
            {
                value: 'X',
                label: 'Sonstiges'
            }
        ],
        loadingCountries: false,
        countryOptions: Object.entries(countries.getNames('de')).map(el => ({ code: el[0], label: el[1] })),
        countries: [
            // must be searched async for performance reasons
            { code: 'DE', label: 'Deutschland' },
            { code: 'NL', label: 'Niederlande' },
            { code: 'FR', label: 'Frankreich' },
            { code: 'AU', label: 'Österreich' },
            { code: 'BE', label: 'Belgien' },
            { code: 'CH', label: 'Schweiz' },
            { code: 'LU', label: 'Luxemburg' }
        ],
        preview: false, // show mapbox and addresses list
        addresses: [], // addresses returned by mapbox geocoding
        selectedAddress: undefined, // selected address from mapbox search
        validMapboxKey: true,
        form: {
            gender: undefined,
            first_name: '',
            last_name: '',
            company: '',
            street: '',
            street_addition: '',
            zipcode: '',
            city: '',
            country: undefined,
            default_billing: undefined,
            default_shipping: undefined,

            edit_member: false
        }
    }),
    components: {
        EditIcon,
        Modal,
        ValidationObserver,
        ValidationProvider,
        SelectWithValidation,
        MapBox,
        Multiselect
    },
    filters: {
        country(value) {
            return countries.getName(value, 'de');
        }
    },
    computed: {
        dirty() {
            let dirty = false;
            if (!this.address || !this.address.id) {
                dirty = true;
            } else {
                if (
                    !this.address.longitude ||
                    !this.address.latitude ||
                    this.address.street !== this.form.street ||
                    this.address.zipcode !== this.form.zipcode ||
                    this.address.city !== this.form.city ||
                    this.address.country !== get(this.form.country, 'code')
                ) {
                    dirty = true;
                }
            }
            return dirty;
        },
        oneLiner() {
            let country = '';
            if (this.address.country) country = countries.getName(this.address.country, 'de');
            return trim(`${this.address.street}, ${this.address.zipcode} ${this.address.city}, ${country}`, ', ');
        },
        salutation() {
            let salutation = '';
            if (this.member.gender === 'M') salutation = 'Herr';
            else if (this.member.gender === 'F') salutation = 'Frau';
            return salutation;
        },
        name() {
            let name = trim(`${this.salutation} ${this.member.first_name} ${this.member.last_name}`);
            if (this.address && (this.address.gender || this.address.first_name || this.address.last_name)) {
                let salutation = '';
                if (this.address.gender === 'M') salutation = 'Herr';
                else if (this.address.gender === 'F') salutation = 'Frau';
                name = trim(`${salutation} ${this.address.first_name} ${this.address.last_name}`);
            }
            if (this.form.first_name || this.form.last_name) {
                let salutation = '';
                if (get(this.form.gender, 'value') === 'M') salutation = 'Herr';
                else if (get(this.form.gender, 'value') === 'F') salutation = 'Frau';
                name = trim(`${salutation} ${this.form.first_name} ${this.form.last_name}`);
            }
            return name;
        },
        company() {
            let company = this.form.company;
            if (!company && this.address && this.address.company) company = this.address.company;
            return company;
        },
        companyAddition() {
            let companyAddition = this.form.company_addition;
            if (!companyAddition && this.address && this.address.company_addition) {
                companyAddition = this.address.company_addition;
            }
            return companyAddition;
        },
        defaultBillingAddressExists() {
            return (
                get(this.member, 'addresses.length') && this.member.addresses.find(el => el.default_billing === true)
            );
        },
        defaultShippingAddressExists() {
            return (
                get(this.member, 'addresses.length') && this.member.addresses.find(el => el.default_shipping === true)
            );
        },
        // countries() {
        //   // return Object.entries(countries.getNames('de')).map(el => ({ code: el[0], label: el[1] }));
        //   let countries = []
        //   for (var i = 0; i < 256; i++) {
        //     countries.push(i);
        //   }
        //   return countries;
        // },
        ...mapGetters({
            member: 'auth/member',
            recaptchaSiteKey: 'googleRecaptchaSiteKey',
            mapboxKey: 'mapboxKey'
        })
    },
    methods: {
        findCountries(query) {
            this.loadingCountries = true;
            this.debouncedFindCountries(query);
        },
        debouncedFindCountries: debounce(function(query) {
            // function scope is needed here
            if (query) {
                const settings = {
                    shouldSort: true,
                    tokenize: true,
                    matchAllTokens: true,
                    threshold: 0.3,
                    minMatchCharLength: 1,
                    keys: ['label']
                };
                const fuse = new Fuse(this.countryOptions, settings);
                this.countries = fuse.search(query).map(el => el.item);
            } else {
                this.resetCountries();
            }
            this.loadingCountries = false;
        }, 300),
        resetCountries() {
            this.countries = [
                { code: 'DE', label: 'Deutschland' },
                { code: 'NL', label: 'Niederlande' },
                { code: 'FR', label: 'Frankreich' },
                { code: 'AU', label: 'Österreich' },
                { code: 'BE', label: 'Belgien' },
                { code: 'CH', label: 'Schweiz' },
                { code: 'LU', label: 'Luxemburg' }
            ];
        },
        findAddresses() {
            if (!this.validMapboxKey) return;
            if (!this.form.street || !this.form.zipcode || !this.form.city || !this.form.country) return;

            const query = `${this.form.street}, ${this.form.zipcode} ${this.form.city}, ${this.form.country.label}`;

            const language = 'de';
            const timestamp = getTime(startOfDay(new Date()));
            const proximity = this.proximity.join(',');

            let url = `${process.env.VUE_APP_MAPBOX_GOECODING_ENDPOINT}${query}.json?access_token=${this.mapboxKey}`;
            url += `&cachebuster=${timestamp}`;
            url += `&autocomplete=true`;
            url += `&language=${language}`;
            url += `&types=postcode,address`;
            url += `&proximity=${proximity}`;

            return axios
                .get(url)
                .then(({ data }) => {
                    let suggestions = [];
                    if (data && data.features && data.features.length) {
                        data.features.forEach(feature => {
                            if (
                                feature.place_name &&
                                feature.place_type.includes('address') &&
                                feature.relevance >= 0.7
                            ) {
                                suggestions.push({ value: feature.place_name, data: feature });
                            }
                        });
                    }

                    this.addresses = suggestions;
                })
                .catch(error => {
                    console.error(error);
                    this.addresses = [];
                });
        },
        click() {
            if (this.address) {
                let gender, country;

                if (this.address.gender) {
                    gender = this.genders.find(el => el.value === this.address.gender);
                }

                if (this.address.country) {
                    const label = countries.getName(this.address.country, 'de');
                    if (label) country = { code: this.address.country, label };
                }

                this.form = {
                    id: this.address.id,
                    gender,
                    first_name: this.address.first_name,
                    last_name: this.address.last_name,
                    company: this.address.company,
                    street: this.address.street,
                    street_addition: this.address.street_addition,
                    zipcode: this.address.zipcode,
                    city: this.address.city,
                    country,
                    default_billing: !this.defaultBillingAddressExists || this.address.default_billing,
                    default_shipping: !this.defaultShippingAddressExists || this.address.default_shipping,

                    edit_member: false
                };
            } else {
                this.form = {
                    gender: undefined,
                    first_name: '',
                    last_name: '',
                    company: '',
                    street: '',
                    street_addition: '',
                    zipcode: '',
                    city: '',
                    country: undefined,
                    default_billing: !this.defaultBillingAddressExists,
                    default_shipping: !this.defaultShippingAddressExists,

                    edit_member: false
                };
            }
            this.modal = true;
        },
        dismiss() {
            // if (this.form.current_password === '' && this.form.email === '') {
            //   this.close();
            // }
        },
        correct() {
            this.preview = false;
            this.addresses = [];
            this.selectedAddress = undefined;
        },
        close() {
            this.modal = false;
            this.loading = false;
            this.$nextTick(() => {
                this.preview = false;
                this.addresses = [];
                this.selectedAddress = undefined;

                this.form = {
                    gender: undefined,
                    first_name: '',
                    last_name: '',
                    company: '',
                    street: '',
                    street_addition: '',
                    zipcode: '',
                    city: '',
                    country: undefined,
                    default_billing: undefined,
                    default_shipping: undefined,

                    edit_member: false
                };
            });
        },
        save(event) {
            this.submit(event, true);
        },
        async submit(event, force = false) {
            this.loading = true;

            // TODO
            // 1. check the current password
            // 2. if succeed: submit member form with new email

            const valid = await this.$refs.form.validate();
            if (!valid) {
                const errorMessage = {
                    id: uniqid(),
                    title: 'Ungültiges Formular',
                    text: 'Korrigieren Sie Ihre Angaben.',
                    type: 'warning',
                    autoclose: 8000
                };
                this.addMessage(errorMessage);
            } else {
                let errorMessage = {
                    id: uniqid(),
                    title: 'Fehler',
                    text:
                        'Es gibt ein technisches Problem.<br>Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.',
                    type: 'error',
                    autoclose: 8000
                };
                if (this.recaptchaSiteKey) {
                    await this.$recaptchaLoaded();
                    try {
                        await this.$recaptcha('auth');
                        if (force === false && this.validMapboxKey && this.selectedAddress === undefined) {
                            await this.findAddresses();

                            // const addresses = this.addresses.filter(el => !!el.data.address);
                            // if (!this.addresses.length) {
                            //   // errorMessage.text = 'Diese Adresse konnte nicht gefunden werden!';
                            //   // this.addMessage(errorMessage);
                            // } else if (!addresses.length) {
                            //   // errorMessage.text = 'Sie haben keine Hausnummer eingetragen!<br>Ergänzen Sie Ihre Angabe.';
                            //   // this.addMessage(errorMessage);
                            // } else {
                            //   this.addresses = addresses;
                            //   this.selectedAddress = addresses[0];
                            //   // show mapbox and ask if the found address is correct
                            //   this.preview = true;
                            // }

                            if (this.addresses.length) {
                                this.selectedAddress = this.addresses[0];
                            } else {
                                this.selectedAddress = false;
                            }
                            // show mapbox and ask if the found address is correct
                            this.preview = true;
                            this.loading = false;
                            return;
                        }

                        let form = cloneDeep(this.form);
                        form.gender = get(this.form.gender, 'value');
                        form.country = get(this.form.country, 'code');
                        delete form.edit_member;

                        // if this.selectedAddress exists and force === false
                        // override the form data with this.selectedAddress
                        if (this.selectedAddress && force === false) {
                            const address = this.selectedAddress;
                            if (address.data && address.data.context && address.data.context.length) {
                                if (address.data.id.startsWith('address')) {
                                    // find street
                                    if (address.data.address)
                                        form.street = trim(`${address.data.text} ${address.data.address}`);
                                    else form.street = address.data.text;
                                }

                                address.data.context.forEach(entry => {
                                    if (entry.id.startsWith('postcode')) {
                                        // find zipcode
                                        form.zipcode = entry.text;
                                    } else if (entry.id.startsWith('place')) {
                                        // find city
                                        form.city = entry.text;
                                    } else if (entry.id.startsWith('country')) {
                                        // find country
                                        form.country = countries.getAlpha2Code(entry.text, 'de');
                                    }
                                });

                                form.latitude = address.data.center[0];
                                form.longitude = address.data.center[1];
                            }
                        }

                        // NOTE
                        // the member save mutation deletes all addresses
                        // which are not present in the request
                        // so all addresses need to be in the payload

                        // This is also the right time to take care
                        // of the correct use of the default_shipping / default_billing flags.
                        // They can only be present once under all addresses

                        const payload = {
                            id: this.member.id,
                            addresses: []
                        };

                        const memberAddresses = cloneDeep(this.member.addresses) || [];
                        memberAddresses.forEach(address => {
                            if (form.id && form.id === address.id) return;
                            if (form.default_shipping) address.default_shipping = false;
                            if (form.default_billing) address.default_billing = false;

                            payload.addresses.push(address);
                        });

                        let text = 'Adresse wurde erfolgreich geändert.';
                        if (!form.id) {
                            form.id = uniqid('new:');
                            text = 'Adresse wurde erfolgreich angelegt.';
                        }
                        payload.addresses.push(form);

                        this.updateMember(payload)
                            .then(() => {
                                this.addMessage({
                                    id: uniqid(),
                                    title: 'Erfolg',
                                    text,
                                    type: 'success',
                                    autoclose: 4000
                                });
                                this.close();
                            })
                            .catch(error => {
                                console.error(error);
                                this.addMessage(errorMessage);
                            })
                            .finally(() => {
                                this.loading = false;
                            });
                    } catch (error) {
                        console.error(error);
                        this.loading = false;
                        this.addMessage(errorMessage);
                    }
                } else {
                    console.error('No ReCaptcha key!');
                    this.loading = false;
                    this.addMessage(errorMessage);
                }
            }
        },
        deleteAddress() {
            // NOTE
            // the member save mutation deletes all addresses
            // which are not present in the request, or are marked as deleted
            // so all addresses (to be kept) need to be in the payload

            // This is also the right time to take care
            // of the correct use of the default_shipping / default_billing flags.
            // Only addresses without those flags can be deleted

            const payload = {
                id: parseInt(this.member.id),
                addresses: []
            };

            const memberAddresses = cloneDeep(this.member.addresses) || [];
            memberAddresses.forEach(address => {
                if (
                    !(this.address.default_billing || this.address.default_shipping) &&
                    this.address.id === address.id
                ) {
                    address.deleted = true;
                }
                payload.addresses.push(address);
            });

            this.updateMember(payload)
                .then(() => {
                    this.addMessage({
                        id: uniqid(),
                        title: 'Erfolg',
                        text: 'Adresse wurde erfolgreich gelöscht.',
                        type: 'success',
                        autoclose: 4000
                    });
                    this.close();
                })
                .catch(error => {
                    console.error(error);

                    const errorMessage = {
                        id: uniqid(),
                        title: 'Fehler',
                        text:
                            'Es gibt ein technisches Problem.<br>Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.',
                        type: 'error',
                        autoclose: 8000
                    };
                    this.addMessage(errorMessage);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        ...mapActions({
            addMessage: 'message/add',
            updateMember: 'auth/updateMember'
        })
    },
    beforeMount() {
        if (this.recaptchaSiteKey) {
            Vue.use(VueReCaptcha, {
                siteKey: this.recaptchaSiteKey,
                loaderOptions: {
                    useRecaptchaNet: true
                }
            });
        }
    },
    mounted() {
        if (this.$refs.info) {
            const padding = this.$refs.info.clientHeight;
            this.padding = { bottom: padding };
        }

        if (this.mapboxKey) {
            const query = 'test';
            let url = `${process.env.VUE_APP_MAPBOX_GOECODING_ENDPOINT}${query}.json?access_token=${this.mapboxKey}`;

            axios.get(url).catch(error => {
                if (error.response.status === 401) {
                    this.validMapboxKey = false;
                }
            });
        } else {
            this.validMapboxKey = false;
        }

        navigator.geolocation.getCurrentPosition(
            position => {
                this.proximity = [position.coords.longitude, position.coords.latitude];
            },
            error => console.error(error)
        );
    }
};
</script>

<style lang="sass" scoped>
a.panel
  padding: 0

.existing
  position: relative
  &::v-deep .map-conaier
    min-height: 246px
  .info
    position: absolute
    bottom: 0
    left: 0
    width: 100%
    min-height: 80px
    background: rgba(255, 255, 255, .7)
    backdrop-filter: blur(5px)
    .delete-button
      @apply rounded-full bg-white text-red-500 p-3 shadow
      outline: none !important
      position: absolute
      top: -2rem
      right: 1rem
      height: 3rem
      width: 3rem
      &:hover,
      &:focus
        @apply bg-red-500 text-white
      &:active
        @apply bg-red-600 text-white

svg.add-icon
  width: 3rem
  height: 3rem

.spinner-container
  position: absolute
  left: 0
  width: 100%
  top: 0
  height: 100%
  z-index: 1
  background: rgba(255, 255, 255, 0.5)
form
  fieldset.form-field:last-child
    @apply mb-0
  .member-fields
    @apply border-b-1 border-gray-400
    padding-bottom: 1rem
    margin-bottom: 1rem
    .field fieldset.form-field
      margin-bottom: 1rem
    .trible-field
      @screen sm
        @apply grid
        grid-column-gap: 1rem
        grid-template-rows: repeat(2, auto)
        grid-template-columns: 160px repeat(2, auto)
  .double-field
    @screen sm
      @apply flex
      --gap: 1rem
      margin: calc(-1 * var(--gap)) 0 0 calc(-1 * var(--gap))
      width: calc(100% + var(--gap))
      .field
        flex-basis: 50%
        margin: var(--gap) 0 0 var(--gap)
    .field fieldset.form-field
      margin-bottom: 1rem
    &:last-child
      .field
        &:last-of-type
          fieldset
            margin-bottom: 0
        fieldset
          @screen sm
            margin-bottom: 0

.preview .grid
  gap: 1rem
  // @screen sm
  //   grid-template-columns: auto max-content
  //   ul.addresses-list
  //     display: flex
  // Alternative
  // @screen sm
  //   grid-template-columns: max-content auto
  //   ul.addresses-list
  //     display: flex
  //     align-items: center
  //     grid-column: 1
  //     grid-row: 1
  //   .map-conaier
  //     grid-column: 2
  //     grid-row: 1
  .pretty
    margin-right: 0
</style>
